import UICardSection from 'UIComponents/card/UICardSection';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UIList from 'UIComponents/list/UIList';
import useLocale from 'developer-docs-shared-components/hooks/useLocale';
import { connect, useDispatch } from 'react-redux';
import { selectSearchResults } from '../../selectors/searchState';
import OldSiteRedirectAlert from './OldSiteRedirectAlert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import styled from 'styled-components';
import { selectSearchQuery } from '../../selectors/searchState';
import { SEARCH, SEARCH_ACTIONS, SEARCH_ORIGINS } from '../../tracking/trackerActions';
import { getUsageTracker } from '../../utils/usage-tracker/index';
import { ResultIcon } from './ResultIcon';
import ResultDescription from './dropdownSearch/ResultDescription';
import { getRouterAwarePathFromProxyUrl } from 'developer-docs-shared-components/utils/urls';
import UIPaginator from 'UIComponents/paginator/UIPaginator';
import { MOBILE_MENU_BREAKPOINT, mediaQueries } from 'developer-docs-shared-components/utils/mediaQueries';
import { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { search } from '../../actions/SearchActions';
import { getOffsetFromPage, getPageMapValueFromTagName, getSearchResultsPageUrl, resultPerPage } from './searchHelpers';
import { SeeEnglishResults } from './SeeEnglishResults';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledCardWrapper = styled(UICardWrapper).withConfig({
  displayName: "ResultsPage__StyledCardWrapper",
  componentId: "lvu19m-0"
})(["margin-bottom:0;padding-left:20px;padding-right:20px;", "{padding-left:60px;padding-right:60px;}"], mediaQueries.aboveWidth(MOBILE_MENU_BREAKPOINT));
const StyledH2 = props => /*#__PURE__*/_jsx(Text, Object.assign({}, props, {
  as: "h2",
  marginBlockStart: "600",
  marginBlockEnd: "400"
}));

/**
 * The search results page, off `/search` for each locale. This route is not
 * indexed by search engines to reduce the crawl budget.
 */
function ResultsPage({
  query,
  searchResults,
  pageNumber
}) {
  const history = useHistory();
  const dispatch = useDispatch();
  const offset = useMemo(() => getOffsetFromPage(pageNumber), [pageNumber]);
  const locale = useLocale();
  const page = pageNumber || 1;
  const handlePageChange = e => {
    const selectedPageIndex = parseInt(e.currentTarget.value, 10);
    const path = getSearchResultsPageUrl(query, selectedPageIndex);
    dispatch(search(query, locale, getOffsetFromPage(selectedPageIndex)));
    history.push(path);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [locale !== 'en-us' && /*#__PURE__*/_jsx(View, {
      paddingBlockEnd: "400",
      as: "div",
      children: /*#__PURE__*/_jsx(SeeEnglishResults, {
        query: query
      })
    }), /*#__PURE__*/_jsxs(StyledCardWrapper, {
      children: [/*#__PURE__*/_jsx(StyledH2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-docs-ui.search.resultsForQuery",
          options: {
            query
          }
        })
      }), /*#__PURE__*/_jsx(UIList, {
        "data-test-id": "search-results",
        children: searchResults.map((result, i) => {
          const link = getRouterAwarePathFromProxyUrl(result.link);
          const primaryCategory = getPageMapValueFromTagName(result, 'developer-docs-ui:category:primary');
          return /*#__PURE__*/_jsxs(UICardSection, {
            className: "p-y-8 p-x-0 flex-row align-center justify-between",
            children: [/*#__PURE__*/_jsx(ResultDescription, {
              onClick: () => getUsageTracker().track(SEARCH, {
                action: SEARCH_ACTIONS.RESULT_SELECTED,
                origin: SEARCH_ORIGINS.STANDARD_SEARCH,
                searchTerm: query,
                offset: offset || 0,
                link
              }),
              result: result
            }), /*#__PURE__*/_jsx(ResultIcon, {
              primaryCategory: primaryCategory
            })]
          }, `${result.title}-${i}`);
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "flex-column align-center",
        children: /*#__PURE__*/_jsx(UIPaginator
        // Disable next button if not available
        , {
          enabledPageLimit: searchResults.length < resultPerPage ? page : resultPerPage,
          maxVisiblePageButtons: 1,
          className: "p-bottom-10 p-x-10",
          onPageChange: handlePageChange,
          page: page,
          pageCount: Infinity
        })
      })]
    }), /*#__PURE__*/_jsx(OldSiteRedirectAlert, {
      className: "p-top-4"
    })]
  });
}
const mapStateToProps = state => ({
  query: selectSearchQuery(state),
  searchResults: selectSearchResults(state)
});
export default connect(mapStateToProps)(ResultsPage);